var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 8.60004V6.20004C17.7 5.90004 18.2 5.30004 18.2 4.60004V4.50004C18.2 3.50004 17.4 2.70004 16.4 2.70004H16.3C15.3 2.70004 14.5 3.50004 14.5 4.50004V4.60004C14.5 5.30004 14.9 5.90004 15.6 6.20004V8.60004C14.7 8.70004 13.8 9.10004 13.1 9.70004L6.49997 4.60004C6.79997 3.50004 6.09997 2.30004 4.99997 2.10004C3.89997 1.90004 2.79997 2.40004 2.49997 3.50004C2.19997 4.60004 2.89997 5.80004 3.99997 6.10004C4.49997 6.20004 5.09997 6.20004 5.59997 5.90004L12 10.9C10.8 12.7 10.8 15 12.1 16.8L10.1 18.8C9.89997 18.8 9.79997 18.7 9.59997 18.7C8.69997 18.7 7.89997 19.5 7.89997 20.4C7.89997 21.3 8.69997 22 9.59997 22C10.5 22 11.3 21.2 11.3 20.3C11.3 20.1 11.3 20 11.2 19.8L13.1 17.9C15.4 19.6 18.7 19.2 20.4 16.9C22.1 14.6 21.7 11.3 19.4 9.60004C18.8 9.10004 18 8.70004 17.1 8.60004ZM16.3 16.4C14.8 16.4 13.6 15.2 13.6 13.7C13.6 12.2 14.8 11 16.3 11C17.8 11 19 12.2 19 13.7C19 15.2 17.8 16.4 16.3 16.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.47834e74.svg";
export { ForwardRef as ReactComponent };